<template>
  <div class="container-fluid h-100">
    <div class="row justify-content-center h-100">
      <div class="col-md-8 col-md-offset-2">
        <b-card border-variant="secondary" class="mt-10" no-body>
          <puls-card-header
            :title="$t('notFound.title')"
            :leftAction="{
              to: { name: 'overview', title: $t('notFound.backButton') }
            }"
          />
          <b-card-body class="d-flex justify-content-center">
            <b-alert :show="true" class="w-lg-50 mt-5">
              <span class="d-flex align-items-center mx-auto">
                <i class="bi bi-info-circle-fill me-3 text-info"></i>
                {{ $t('notFound.alert') }}
              </span>
            </b-alert>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { PulsCardHeader } from '@puls-solutions/puls-ui-components'
export default {
  name: 'NotFound',
  components: { PulsCardHeader }
}
</script>

<style scoped></style>
